module.exports = __webpack_public_path__ + "static/style-guide-mobile-50c06d39c2b7867bec4b42d4302ba4f1.jpg";